const initialState = { admin: null };

export default (state = initialState, action) => {
  switch (action.type) {
    case "sigin":
      return { ...state, token: action.payload };
    case "SET_ADMIN":
      return { ...state, admin: action.payload };
    default:
      return state;
  }
};
